import React from 'react';

import { Cell, List } from 'ui-builder';
import { GridLayout, GridLayoutTheme, Accordion } from 'features/nekst-widgets';
import { DateFieldValue, DetailFieldName, LinkedTaskCell } from './DetailFieldCells';
import { ProjectDetailFieldRow } from './types';
import CompletedDatesToggle, { useCompletedDatesFilter } from './CompletedDatesToggle';
import EditableFieldCell from './EditableFieldCell';

export default function DatesFieldsBlock(props: { fields: ProjectDetailFieldRow[] }) {
  const {
    visibleFields, getRowClassName, completedCount, showCompleted, setShowCompleted,
  } = useCompletedDatesFilter(props.fields);

  return (
    <Accordion
      title="Dates"
      count={props.fields.length}
      defaultOpen
      sectionId="dates"
      pageContext="transaction-detail"
    >
      <List
        getDataFunc={async () => visibleFields}
        dependencies={[JSON.stringify(visibleFields)]}
      >
        <GridLayout
          theme={GridLayoutTheme.LIGHT}
          weights={[1, 1, 1]}
          noDataMessage="No date fields."
          rowClassName={getRowClassName}
        >
          <Cell label="Detail" isCentered={false}>
            <DetailFieldName />
          </Cell>
          <Cell label="Value" isCentered={false}>
            <EditableFieldCell>
              <DateFieldValue />
            </EditableFieldCell>
          </Cell>
          <Cell label="Linked Task" isCentered={false}>
            <LinkedTaskCell />
          </Cell>
        </GridLayout>
      </List>
      <CompletedDatesToggle
        completedCount={completedCount}
        showCompleted={showCompleted}
        onToggle={() => setShowCompleted(!showCompleted)}
      />
    </Accordion>
  );
}
